// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__30lVi","insightsList":"newBusinessInsightsMenu_insightsList__2uTJI","active":"newBusinessInsightsMenu_active__2w6aq"};